export default __webpack_public_path__ + "static/media/craftyClub.b2141dae.png";